import api from "@/api";

export default {
    namespaced: true,

    state: {},

    actions: {
        async createComment(context, {voteId, commentText, feedbackEmail}) {
            console.log('voteId, commentText', voteId, commentText, feedbackEmail)
            const prefix = context.rootState.auth.accessToken ? 'v1/' : ''
            var contact = feedbackEmail
            if(feedbackEmail !== '') {
                feedbackEmail = `|${feedbackEmail}`
            }
            let url = `/api/${prefix}votes/${voteId}/comment?comment=${encodeURIComponent(`${commentText}${feedbackEmail}`)}`;
            return await api.request("put", url);
        }
    }
};
